import { Component, OnInit } from '@angular/core';
import { users } from '../../../../interfaces/users';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeliveryService } from '../../../../services/delivery';
import { ItemsService } from '../../../../services/items.service';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
@Component({
  selector: 'app-deliveryherocollecting',
  templateUrl: './deliveryherocollecting.component.html',
  styleUrl: './deliveryherocollecting.component.scss',

})
export class DeliveryherocollectingComponent implements OnInit {

  userData!: users;
  data!: any;
  id!: any;
  name!: any;
  job_title!: any;
  salary!: any;

  contentReady: boolean = true;

  collectedFromDH: any[] = [];
  herosd: any;
  date: any;

  AllHeros: any;
  heros: any;

  isAr: boolean = localStorage.getItem("language") == "ar";

  amount!: any;
  note!: any;
  finId!: any;

  noteSearch: string = '';
  accountType!: string;
  isAdmin!: boolean;
  isMobile!: boolean;
  isSubAdmin!: boolean;
  dailyChart: any;
  heroChart: any;
  ordersChart: any;
  monthlyChart: any;
  hasData: boolean = false;
  totalCollected: any = 0;
  currentPage: number = 1;
  lastPage: number = 1;
  totalItems: number = 0;
  warehouseId: any;
  allWareHouses: any;
  totalAmount: any = 0;
  // إضافات UI (اختياري لكنها مفيدة)
  totalCount: number = 0;

  constructor(
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private _deliveryhero: DeliveryService
  ) { }

  ngOnInit() {
    this.contentReady = false;

    this.warehouseId = localStorage.getItem("posId");

    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse;
      },
      error: () => { },
    });

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";
      },
      error: (error) => console.error(error),
    });

    // default date = today
    this.date = new Date().toISOString().split('T')[0];

    this.getallFromHeros(this.warehouseId);
    this.getAllHeros(this.warehouseId, false);
  }

  applyWareHouse(warehouseId: any) {
    this.warehouseId = warehouseId;
    this.getallFromHeros(this.warehouseId);
    this.getAllHeros(this.warehouseId, false);
  }

  getAllHeros(warehouse_id: any, hasPagination: boolean) {
    this.contentReady = true;
    this._deliveryhero.getAllDeliveryStars(warehouse_id, hasPagination).subscribe({
      next: (data) => {
        this.heros = data;

        // set default selected hero
        if (this.heros?.length > 0) {
          // انت عندك في الكود القديم herosd = hero.link
          // لكن في الفلترة بتعمل parseInt(herosd) => الأفضل نخليها id/phone/whatever رقم
          // لو link هو اللي لازم يتبعت، سيبه زي ما هو.
          this.herosd = this.heros[0].link ?? this.heros[0].phone ?? this.heros[0].id;
        }

        this.contentReady = false;
      },
      error: (error) => console.error(error),
    });
  }

  getallFromHeros(warehouse_id: any, page: number = 1) {

    this.contentReady = true;

    this._deliveryhero
      .getAllDeliveryCollections(warehouse_id, page, 10)
      .subscribe({
        next: (res: any) => {

          this.collectedFromDH = res.data || [];
          this.currentPage = res.current_page;
          this.lastPage = res.last_page;
          this.totalItems = res.total;
          this.totalCount = res.total_orders_month;
          this.totalAmount = res.total_amount_month;
          this.recalcSummary();
          this.hasData = this.collectedFromDH.length === 0;

          this.contentReady = false;
        },
        error: (err) => console.error(err),
      });
  }
  changePage(page: number) {

    if (page < 1 || page > this.lastPage) return;

    this.currentPage = page;
    this.getallFromHeros(this.warehouseId, page);
  }
  // كان موجود عندك - سيبناه (لو بتستخدمه في زرار submit أو future)
  onSubmit() {
    this.contentReady = true;

    this._deliveryhero.getCollectionsByStarAndDate(this.herosd, this.date).subscribe({
      next: () => {
        this.contentReady = false;
      },
      error: (error) => console.error(error),
    });
  }

  delete(id: any) {
    Swal.fire({
      title: this.isAr ? "متأكد؟؟" : "Are You Sure?",
      showCancelButton: true,
      confirmButtonText: this.isAr ? "اه" : "YES",
      cancelButtonText: this.isAr ? "لا" : "no"
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;

        this._deliveryhero.deleteDeliveryCollection(id).subscribe({
          next: () => {
            this.getallFromHeros(this.warehouseId, this.currentPage);
          },
          error: (err) => console.log(err),
        });

      }
    });
  }

  dayChange() {
    this.getCollectedFromHero();
  }

  filterAllHeros() {
    this.getCollectedFromHero();
  }

  getCollectedFromHero() {
    this.contentReady = true;

    // نفس منطقك القديم
    this._deliveryhero.getAllDeliveryCollections(parseInt(this.herosd), this.date).subscribe({
      next: (data) => {
        this.collectedFromDH = data?.data || [];
        this.recalcSummary();

        this.contentReady = false;

        this.hasData = (this.collectedFromDH.length === 0);
      },
      error: (error) => console.error(error),
    });
  }

  private recalcSummary() {

    this.totalCollected = (this.collectedFromDH || [])
      .reduce((acc, item) => acc + Number(item.amount_collected || 0), 0);

    this.buildCharts();

  }
  buildCharts() {

    if (!this.collectedFromDH || this.collectedFromDH.length === 0) return;

    const labels = this.collectedFromDH.map(x => x.order_id);
    const amounts = this.collectedFromDH.map(x => Number(x.amount_collected));

    this.dailyChart = {
      labels: labels,
      datasets: [
        {
          label: 'Revenue',
          data: amounts
        }
      ]
    };


    let heroMap: any = {};

    this.collectedFromDH.forEach(x => {
      heroMap[x.sub_dilivery_id] =
        (heroMap[x.sub_dilivery_id] || 0) + Number(x.amount_collected);
    });

    this.heroChart = {
      labels: Object.keys(heroMap),
      datasets: [
        {
          label: 'Collected',
          data: Object.values(heroMap)
        }
      ]
    };


    let ordersMap: any = {};

    this.collectedFromDH.forEach(x => {
      ordersMap[x.sub_dilivery_id] =
        (ordersMap[x.sub_dilivery_id] || 0) + 1;
    });

    this.ordersChart = {
      labels: Object.keys(ordersMap),
      datasets: [
        {
          data: Object.values(ordersMap)
        }
      ]
    };


    let monthlyMap: any = {};

    this.collectedFromDH.forEach(x => {
      let d = new Date(x.created_at || new Date());
      let m = d.getMonth() + 1;

      monthlyMap[m] =
        (monthlyMap[m] || 0) + Number(x.amount_collected);
    });

    this.monthlyChart = {
      labels: Object.keys(monthlyMap),
      datasets: [
        {
          label: 'Monthly Revenue',
          data: Object.values(monthlyMap)
        }
      ]
    };

  }
}
